import * as React from 'react';
import ApplicationRouter from './application-router';
import './app.scss';
import { AppContextProvider } from './shared/app-context';
import { datadogRum, Datacenter } from '@datadog/browser-rum';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

declare global {
  /* tslint:disable interface-name */
  interface Window {
    tableau: any;
    env: {
      BASE_URL: string;
      BASE_API: string;
      MANAGEMENT_URL: string;
      USER_INTERFACE: string;
      // client token provided by datadog to use in RUM api calls
      RUM_CLIENT_TOKEN?: string;
      // set rum samplerate to something other than 100 (all sessions tracked)
      RUM_SAMPLERATE?: string;
      OKTA_CLIENT_ID: string;
      OKTA_ISSUER: string;
      OKTA_REQUEST_CONTEXT: string;
    };
  }
}

// default RUM sampleRate to 100% of sessions
let rumSamplerate = 100;
if (window.env.RUM_SAMPLERATE !== undefined && window.env.RUM_SAMPLERATE !== '==window.env.RUM_SAMPLERATE==') {
  rumSamplerate = Number(window.env.RUM_SAMPLERATE);
}

// don't try to initialize RUM without client token
if (window.env.RUM_CLIENT_TOKEN !== undefined) {
  datadogRum.init({
    applicationId: '13b91b9e-49c3-4691-a42f-2ed537c89a02',
    clientToken: window.env.RUM_CLIENT_TOKEN,
    datacenter: Datacenter.US,
    sampleRate: rumSamplerate
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30
    }
  }
});

const Application = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AppContextProvider>
        <ApplicationRouter />
      </AppContextProvider>
      {/* NB: React Query Dev Tools only included when process.env.NODE_ENV == 'development' */}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default Application;
